import get from 'transmute/get';
import { EMAIL_PREVIOUS_REPLIES } from '../constants/attachmentTypes';
import { getAttachments } from './getAttachments';
const isEmailPreviousReplies = attachmentObject => Boolean(attachmentObject && get('@type', attachmentObject) === EMAIL_PREVIOUS_REPLIES);
export const getEmailPreviousReplies = commonMessage => {
  const attachments = getAttachments(commonMessage);
  if (attachments) {
    return attachments.find(isEmailPreviousReplies);
  }
  return undefined;
};